import React from 'react'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { Typography, Grid, ButtonBase } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import settingsStyles from '../settingsStyles'
import { trackEvent } from '../../../helpers/analytics'

function PageLink({
  title,
  description,
  link,
  path,
  icon,
  action,
  eventName = 'uxp_settings_item_click',
  section = 'Settings',
}) {
  const classes = settingsStyles()
  const dispatch = useDispatch()
  const handleClick = () => {
    trackEvent(dispatch, {
      eventName,
      module: 'Settings',
      object: 'PageLink',
      action: 'Click',
      actionContext: section,
      actionContextValue: title,
    })
    if (link) {
      link(path)
    } else if (action) {
      action()
    }
  }
  return (
    <ButtonBase className={classes.fullWidth} onClick={handleClick}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.linkGrid}
      >
        <Grid item xs container direction="column" alignItems="flex-start">
          <Typography variant="h6">{title}</Typography>
          <Typography variant="caption">{description}</Typography>
        </Grid>
        <Grid item>{icon || <ArrowForwardIosIcon tabIndex={-1} />}</Grid>
      </Grid>
    </ButtonBase>
  )
}

export default PageLink
